<template>
    <div class="commerce-find-num">
        <div class="msg" v-if="globalLang != 'kz/'">Найдено {{ filterCommerceDataBase.filter_items_count }} {{correctWord}}</div>
        <div class="msg" v-if="globalLang == 'kz/'">{{ filterCommerceDataBase.filter_items_count }} нұсқа табылды</div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'commerce-find-num',
        components: {
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
                correctWord: null,
            }
        },
        computed: mapGetters({
            filterCommerceDataBase: 'loadFilterCommerceData',
        }),
        methods: {
            correctFindWord() {
                function pluralizeWord(number, word) {
                    const lastDigit = number % 10;
                    if (number == 1) {
                        return word + ""; // Для чисел, заканчивающихся на 1 или 8
                    } else if (lastDigit >= 2 && lastDigit <= 4) {
                        return word + "а"; // Для чисел, заканчивающихся на 2-4
                    } else {
                        return word + "ов"; // Для всех остальных чисел
                    }
                }
                const word = 'вариант';
                this.correctWord = pluralizeWord(this.filterCommerceDataBase.filter_items_count, word);
            }
        },
        created () {
            this.correctFindWord();
        },
        mounted() {
            this.$store.watch(
                (state) => state.filterCommerce_Data.filter_items_count,
                (newValue) => {
                    if (newValue) {
                        this.correctFindWord();
                    }
                }
            );
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/commerce-page/commerce-find-num.scss';
    @import '@/styles/components/commerce-page/respond/commerce-find-num-respond.scss';
</style>